import React from 'react';
import { useRouter } from 'next/router';

const courseOutline = [
    {
        id: 0,
        title: 'Outline',
        slug: '',
        quickSummary: 'Course Structure / Outline',
    },
    {
        id: 1,
        title: 'Introduction',
        slug: 'ielts-2-introduction-formats',
        quickSummary: 'Learn the basics of Task 2, its format, and different question types.',
    },
    {
        id: 2,
        title: 'Topics',
        slug: 'ielts-2-common-topics-planning',
        quickSummary: 'Discover common essay topics and learn how to brainstorm and plan your response effectively.',
    },
    {
        id: 3,
        title: 'Intros/Conclusions',
        slug: 'ielts-2-introductions-conclusions',
        quickSummary: 'Understand how to write engaging introductions and conclusions for a high-scoring essay.',
    },
    {
        id: 4,
        title: 'Body',
        slug: 'ielts-2-body-paragraphs-strong-arguments',
        quickSummary: 'Learn to structure body paragraphs and present persuasive arguments for a well-organized essay.',
    },
    {
        id: 5,
        title: 'Samples',
        slug: 'ielts-2-sample-answers-analysis',
        quickSummary: 'Examine high-scoring IELTS essays and recognize the essential elements of a top-scoring response.',
    },
    {
        id: 6,
        title: 'Vocab/Grammar',
        slug: 'ielts-2-vocabulary-grammar',
        quickSummary: 'Build a strong vocabulary for various essay topics and grasp crucial grammar rules for successful writing.',
    },
    {
        id: 7,
        title: 'Practice',
        slug: 'ielts-2-practice-strategies',
        quickSummary: 'Gain insights into effective practice techniques, self-assessment, and strategies to avoid common errors.',
    },
    {
        id: 8,
        title: 'Test Day',
        slug: 'ielts-2-test-day-preparation',
        quickSummary: 'Discuss crucial test day preparation tips and last-minute strategies to ensure your best performance.',
    },
];

const CourseOutlineMenu = () => {
    const router = useRouter();
    const activeSlug = router.asPath.split('/')[2] || courseOutline[0].slug;

    const activeItemIndex = courseOutline.findIndex((item) => item.slug === activeSlug);
    const progress = ((activeItemIndex) / (courseOutline.length - 1)) * 100;

    return (
        <div className="w-full sticky top-0 z-50 bg-white pb-1">
            <div className="w-full h-4 bg-gray-300 rounded-md mb-4 relative">
                <div
                    className="h-4 bg-gradient-to-r  from-cyan-500 to-blue-500 "
                    style={{ width: `${progress}%` }}
                >
                    <span className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-xs font-semibold text-white">
                        {progress.toFixed(0)}%
                    </span>
                </div>
            </div>
            <div className="flex flex-wrap items-center justify-center space-x-1 md:space-x-4 overflow-x-auto md:overflow-visible mb-4">
                {courseOutline.map((item) => (
                    <button
                        key={item.id}
                        className={`my-1 px-1 py-1 md:px-3 md:py-1.5 font-semibold text-white rounded-md text-xs md:text-sm ${activeSlug === item.slug ? 'bg-blue-600' : 'bg-blue-400'
                            }`}
                        onClick={() => router.push(`/ielts-essay-course/${item.slug}`)}
                    >
                        {item.id}. {item.title}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CourseOutlineMenu;
